import styled from "styled-components";

export const GalleryContainer = styled.div`
    background: #ABA3F1;
`

export const GalleryWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    justify-content: center;
    max-width: 1100px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 80px;
    

`

export const GalleryH1 = styled.h1`
    text-align: center;
    padding-top: 40px;
    color: white;
    text-shadow: 1.5px 1.5px 1px black;
`

export const Single = styled.div`
    width: 300px;
    cursor: pointer;
`

export const SingleImage = styled.img`
    max-width: 100%;

    &:hover {
        transform: scale(1.02);
    }
`

export const SliderWrap = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    @media screen and (max-width: 768px){
        /* display: none; */
    }
`

export const BtnClose = styled.div`
    position: fixed;
    cursor: pointer;
    opacity: 0.6;
    color: #fff;
    font-size: 32px;
    z-index: 9999;
    top: 40px;
    right: 40px;

    &:hover {
        opacity: 1;
    }

    @media screen and (max-width:768px){
        transform: translateY(450%);
    }
`

export const BtnPrev = styled.div`
    position: fixed;
    cursor: pointer;
    opacity: 0.6;
    color: #fff;
    font-size: 32px;
    z-index: 9999;
    top: 50%;
    transform: translateY(-50%);
    left: 40px;

    &:hover {
        opacity: 1;
    }
`

export const BtnNext = styled.div`
    position: fixed;
    cursor: pointer;
    font-size: 32px;
    opacity: 0.6;
    color: #fff;
    z-index: 9999;
    top: 50%;
    transform: translateY(-50%);
    right: 40px;

    &:hover {
        opacity: 1;
    }
`

export const FullScreenImage = styled.div`
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    display: flex;
    align-items: center;
    justify-content: center;
`

export const FSImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    pointer-events: none;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */  
`